import { render, staticRenderFns } from "./animationUpload.vue?vue&type=template&id=178ddc3a&scoped=true"
import script from "./animationUpload.vue?vue&type=script&lang=js"
export * from "./animationUpload.vue?vue&type=script&lang=js"
import style0 from "./animationUpload.vue?vue&type=style&index=0&id=178ddc3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ddc3a",
  null
  
)

export default component.exports